import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

import type { Notification } from '@/lib/schemas/discovery';

/**
 * The face of a notification nobody sent.
 *
 * Verification and moderation outcomes come from the system, so there is no
 * actor to show and the row would otherwise render an avatar containing a
 * middle dot — which reads as a picture that failed to load.
 *
 * Shared by the page and the bell deliberately: two copies of this drift, and
 * the bell is exactly where nobody would notice.
 *
 * Shape carries the meaning, not colour: a check, a warning triangle, a gavel.
 */
export function SystemNotificationIcon({ type }: { type: Notification['type'] }) {
  if (type === 'VERIFICATION_APPROVED') {
    return <VerifiedRoundedIcon fontSize="small" aria-hidden sx={{ color: 'business' }} />;
  }

  if (type === 'VERIFICATION_REJECTED') {
    return <ReportProblemRoundedIcon fontSize="small" aria-hidden sx={{ color: 'warning.main' }} />;
  }

  if (type === 'MOD_ACTION') {
    return <GavelRoundedIcon fontSize="small" aria-hidden sx={{ color: 'text.secondary' }} />;
  }

  return <NotificationsRoundedIcon fontSize="small" aria-hidden sx={{ color: 'text.secondary' }} />;
}
